export default "__VITE_ASSET__CGh8wt2f__"